import React, {useEffect, useRef, useState} from 'react';
import {Button, FormControl, Spinner} from 'react-bootstrap';
import {BsEye, BsEyeSlashFill} from 'react-icons/bs';
import {useFormikContext} from 'formik';
import config from 'react-global-configuration';
import {getJson} from '../../components/AjaxHelpers';

const CosClientSecretField = ({organizationId, configured, onSecretLoaded}) => {
    const {values, setFieldValue, handleBlur} = useFormikContext();
    const [visible, setVisible] = useState(false);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const request = useRef(null);

    useEffect(() => () => request.current?.unsubscribe(), []);

    const toggleVisibility = () => {
        if (visible || values.cosClientSecret || !configured) {
            setVisible(!visible);
            return;
        }
        setLoading(true);
        setError(null);
        request.current = getJson({
            url: config.get('apiBaseUrl') + '/careUnits/v1/'
                + encodeURIComponent(organizationId) + '/client-secret',
        }).subscribe({
            next: ({cosClientSecret}) => {
                onSecretLoaded(cosClientSecret);
                setFieldValue('cosClientSecret', cosClientSecret);
                setVisible(true);
                setLoading(false);
            },
            error: () => {
                setError('Kunde inte visa sparat client secret. Du kan fortfarande ange ett nytt värde.');
                setLoading(false);
            },
        });
    };

    return <>
        <div className="SaveCareUnitDialog-secret-field">
            <FormControl
                type={visible ? 'text' : 'password'}
                name="cosClientSecret"
                aria-label="COS Client-Secret"
                autoComplete="new-password"
                value={values.cosClientSecret}
                onChange={event => setFieldValue('cosClientSecret', event.target.value)}
                onBlur={handleBlur}
                disabled={loading}
                placeholder={configured ? 'Sparat värde – lämna tomt för att behålla' : 'Ange client secret'}
            />
            <Button type="button" onClick={toggleVisibility} disabled={loading}
                    aria-label={visible ? 'Dölj client secret' : 'Visa client secret'}>
                {loading ? <Spinner size="sm" animation="border"/> : visible ? <BsEyeSlashFill/> : <BsEye/>}
            </Button>
        </div>
        {configured && <div className="text-muted small">Lämna tomt för att behålla sparat värde, eller ange ett nytt.</div>}
        {error && <div role="alert" className="text-danger small">{error}</div>}
    </>;
};

export default CosClientSecretField;
